<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            prop="seq"
          ></el-table-column>
          <el-table-column label="职位">
            <template slot-scope="scope">
              {{ scope.row.title || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="薪资" width="150">
            <template slot-scope="scope">
              {{ scope.row.salary || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="经验(年)" width="80">
            <template slot-scope="scope">
              {{ scope.row.years || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="地点">
            <template slot-scope="scope">
              {{ scope.row.location || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="学历" width="120">
            <template slot-scope="scope">
              {{ scope.row.education || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="发布日期" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.date || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100px"
            fixed="right"
            align="center"
            fit="true"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看详情"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  circle
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :total="total"
            :background="background"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      title="开庭公告详情"
      :visible.sync="flag"
      :close-on-click-modal="false"
      width="55%"
      append-to-body
      @close="close"
    >
      <table
        class="info-table"
        cellspacing="0"
        style="width: 100%; height: 100%"
      >
        <tbody>
          <tr>
            <td>职位名称</td>
            <td>{{ report.title || "-" }}</td>
            <td>发布日期</td>
            <td>{{ report.date || "-" }}</td>
          </tr>
          <tr>
            <td>工作地点</td>
            <td>{{ report.location || "-" }}</td>
            <td>薪资待遇</td>
            <td>{{ report.salary || "-" }}</td>
          </tr>
          <tr>
            <td>学历要求</td>
            <td>{{ report.education || "-" }}</td>
            <td>工作经验</td>
            <td>{{ report.years || "-" }}</td>
          </tr>
          <tr>
            <td>工作类型</td>
            <td>{{ report.job_type || "-" }}</td>
            <td>招聘人数</td>
            <td>{{ report.number || "-" }}</td>
          </tr>
          <tr>
            <td>职位描述</td>
            <td colspan="3">{{ report.description || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
  import { getJobInfo } from "@/api/workplace/companyInfo";

  export default {
    name: "JobInfo",

    data() {
      return {
        flag: false,
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        report: {},
        obj: null,
      };
    },

    methods: {
      getJobInfo(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;
        getJobInfo(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getJobInfo(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getJobInfo(this.obj);
      },
      showDetail(row) {
        this.flag = true;
        this.report = row;
      },
      close() {
        this.flag = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-table {
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    tr td {
      border: 1px solid #ccc;
      padding: 10px;

      &:nth-of-type(even) {
        width: 35%;
        font-weight: normal;
      }

      &:nth-of-type(odd) {
        width: 15%;
        background: #f5f7fa;
      }
    }
  }
</style>
